__turbopack_context__.v({
  "accordionSlideOverwrite": "volunteerInformation-module-scss-module__PFpp2W__accordionSlideOverwrite",
  "checkboxes": "volunteerInformation-module-scss-module__PFpp2W__checkboxes",
  "datePicker": "volunteerInformation-module-scss-module__PFpp2W__datePicker",
  "eventCardWrapper": "volunteerInformation-module-scss-module__PFpp2W__eventCardWrapper",
  "fadeIn": "volunteerInformation-module-scss-module__PFpp2W__fadeIn",
  "fadeOut": "volunteerInformation-module-scss-module__PFpp2W__fadeOut",
  "form": "volunteerInformation-module-scss-module__PFpp2W__form",
  "highlight": "volunteerInformation-module-scss-module__PFpp2W__highlight",
  "inputLabel": "volunteerInformation-module-scss-module__PFpp2W__inputLabel",
  "placeholder": "volunteerInformation-module-scss-module__PFpp2W__placeholder",
  "row": "volunteerInformation-module-scss-module__PFpp2W__row",
  "scaleIn": "volunteerInformation-module-scss-module__PFpp2W__scaleIn",
  "scaleOut": "volunteerInformation-module-scss-module__PFpp2W__scaleOut",
  "signIn": "volunteerInformation-module-scss-module__PFpp2W__signIn",
  "volunteerHeader": "volunteerInformation-module-scss-module__PFpp2W__volunteerHeader",
  "volunteerTitle": "volunteerInformation-module-scss-module__PFpp2W__volunteerTitle",
  "zoomIn": "volunteerInformation-module-scss-module__PFpp2W__zoomIn",
  "zoomOut": "volunteerInformation-module-scss-module__PFpp2W__zoomOut",
});
